import { useRichText } from "@hooks/useRichText";
import { ComponentProps, FromSanityGraphQL } from "@ts/components";
import { SectionCollectionHeroBanner } from "@ts/sanity";
import React, { FC } from "react";

type CollectionHeroBannerInputProps = ComponentProps &
  FromSanityGraphQL<SectionCollectionHeroBanner> & {
    collectionTitle: string;
  };

export type CollectionHeroBannerOutputProps = CollectionHeroBannerInputProps;

export const withCollectionHeroBanner =
  (Component: FC<CollectionHeroBannerOutputProps>) =>
  ({
    name = "CollectionHeroBanner",
    collectionTitle,
    desktopBanner,
    location,
    mobileBanner,
    ...props
  }: CollectionHeroBannerInputProps) => {
    const { parseContent } = useRichText();

    const desktop = parseContent(desktopBanner);
    const mobile = parseContent(mobileBanner);

    return (
      <Component
        collectionTitle={collectionTitle}
        desktopBanner={desktop}
        mobileBanner={mobile}
        location={location}
        {...props}
      />
    );
  };
